export enum ModalEnum {
  InvoiceManagement = 'orderScreen.invoiceManagement',
  ModalFade = 'Modal Fade',
  ModalCancelReturn = 'ModalCancelReturn',
  ModalChangeStatusItem = 'ModalChangeStatusItem',
  Default = 'ModalSide'
}

